var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exchange-detail detail-padding padding-nav" },
    [
      _c(
        "el-button",
        {
          staticClass: "upper",
          staticStyle: { "margin-bottom": "0.16rem" },
          attrs: { type: "text", icon: "el-icon-d-arrow-left" },
          on: { click: _vm.goback },
        },
        [_vm._v("Go\n    back")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "spaceBetween",
          staticStyle: { "margin-bottom": "0.24rem" },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "spaceLeft search-form" },
            [
              _c(
                "div",
                { staticClass: "sapceLeft search-item" },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.getList },
                      model: {
                        value: _vm.searchParams.isExtractedUnit,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParams, "isExtractedUnit", $$v)
                        },
                        expression: "searchParams.isExtractedUnit",
                      },
                    },
                    [_vm._v("Not extracted Unit")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("search-date", {
                attrs: { label: "Closing time" },
                on: {
                  dateChange: function ($event) {
                    return _vm.dateChange($event, "overtime")
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sapceLeft search-item" },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "No...",
                      "suffix-icon": "el-icon-search",
                    },
                    on: { change: _vm.getList },
                    model: {
                      value: _vm.searchParams.number,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchParams, "number", $$v)
                      },
                      expression: "searchParams.number",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "common-card" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "common-table",
              attrs: { data: _vm.tableList, "highlight-current-row": "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "number",
                  label: "No.",
                  align: "left",
                  width: "80px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " + _vm._s(row.number) + "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "overtime",
                  label: "Closing Time",
                  width: "220",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.moment
                                .utc(row.overtime)
                                .format("YYYY-MM-DD HH:mm:ss")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "auction",
                  label: "Auction",
                  align: "right",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.amount } }),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("UNIT"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "highValue",
                  label: "Current Bid",
                  align: "right",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.highValue } }),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("TCash"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "account",
                  label: "Winning Bidder",
                  "show-overflow-tooltip": "",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("account", { attrs: { value: _vm.getWinner(row) } }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "data5", label: "My bid", width: "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c("big-number", {
                              attrs: {
                                number:
                                  row.auctiondetail[0] &&
                                  row.auctiondetail[0].amount,
                              },
                            }),
                            _vm._v(" TCash\n          "),
                            _c(
                              "div",
                              {
                                staticClass: "td-word-sm",
                                staticStyle: { "margin-left": "0.1rem" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.moment
                                      .utc(row.timestamp)
                                      .format("YYYY-MM-DD HH:mm:ss")
                                  ) + "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "TCash withdrawal status",
                  align: "center",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm.showUSTNBtn(row)
                          ? _c("span", { staticClass: "xiaohao" }, [
                              _c("i", { staticClass: "iconfont trn-xiaohao" }),
                              _vm._v("Not extracted"),
                            ])
                          : row.auctiondetail[0] &&
                            row.auctiondetail[0].extractStatus == 2
                          ? _c("span", { staticClass: "xiaohao" }, [
                              _c("i", { staticClass: "iconfont trn-xiaohao" }),
                              _vm._v("Extracted"),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  prop: "data7",
                  label: "Auction status",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm.showUnitBtn(row)
                          ? _c("span", { staticClass: "xiaohao" }, [
                              _c("i", { staticClass: "iconfont trn-xiaohao" }),
                              _vm._v("Not extracted"),
                            ])
                          : row.status == 3
                          ? _c("span", { staticClass: "xiaohao" }, [
                              _c("i", { staticClass: "iconfont trn-xiaohao" }),
                              _vm._v("Extracted"),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "500",
                  prop: "oper",
                  label: "Operation",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm.showUSTNBtn(row)
                          ? _c(
                              "el-button",
                              {
                                staticClass: "o-btn",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.extractDialog(1, row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            Extract Tcash\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showUnitBtn(row)
                          ? _c(
                              "el-button",
                              {
                                staticClass: "o-btn",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.extractDialog(2, row)
                                  },
                                },
                              },
                              [_vm._v("\n            Extract UNIT\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isOver(row.overtime)
                          ? _c(
                              "el-button",
                              {
                                staticClass: "o-btn",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.toAdd(row)
                                  },
                                },
                              },
                              [_vm._v("Add bid")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "o-btn",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.toDetail(row)
                              },
                            },
                          },
                          [_vm._v("Details")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            attrs: {
              total: _vm.queryParams.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.pageSize,
            },
            on: {
              "update:total": function ($event) {
                return _vm.$set(_vm.queryParams, "total", $event)
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "pageSize", $event)
              },
              pagination: function ($event) {
                return _vm.getList()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("extractBidsDialog", {
        ref: "extractBidsDialog",
        on: { refresh: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spaceLeft" }, [
      _c("div", { staticClass: "detail-title-1" }, [
        _vm._v("My bidding history"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }